Wee.routes.addFilter({
	'isPaginated': function(seg) {
		return /^p\d+$/.test(seg);
	},
	'notPaginated': function(seg) {
		return seg && ! /^p\d+$/.test(seg);
	}
});

Wee.routes.map({
	'$any:once': [
		'common',
		'common:alert',
		'common:initHistory',
		'search'
	],
	'$any': ['navigation', 'cart'],
	'news': {
		'$root': 'news',
		'$slug': {
			'$root||$isPaginated': function() {
				if (Wee.$get('newsCategory')) {
					Wee.news.init();
				} else {
					Wee.newsDetail.init();
				}
			}
		},
		'$slug:unload': 'newsDetail:unload'
	},
	'contact': 'contact',
	'news:unload': 'news:unload',
	'faq': 'faq',
	'faq:unload': 'faq:unload',
	'products': {
		'$root': 'products',
		'$slug': {
			'$root': 'products',
			'$isPaginated': {
				'$root': 'products'
			},
			'$notPaginated': ['detailLayout', 'options', 'changeView', 'quantity'],
			'$notPaginated:unload': ['options:unload', 'changeView:unload', 'quantity:unload']
		}
	},
	'products:unload': [
		'products:unload',
		'options:unload'
	],
	'search-results': {
		'$any': ['search-results', 'news'],
		'unload': ['search-results:unload', 'news:unload']
	},
	'quote': {
		'$root': ['storage:get', 'cart']
	},
	'quote-form': 'quoteForm',
	'quote-form:unload': 'quoteForm:unload',
	'gallery': {
		'$any': 'gallery',
		'$any:unload': 'gallery:unload'
	}
});

Wee.ready(function() {
	var routes = {};

	routes[Wee.$get('landingPageRoutes')] = {
		'$root': 'landingPage'
	};

	routes[Wee.$get('landingPageRoutesUnload')] = 'landingPage:unload';

	Wee.routes.map(routes);

	Wee.routes.run();
});